import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearDesignTabTarget,
  pushToHistoryAction,
  setSegmentIcon,
  setWheelPortrait,
} from "../../../../redux/reducers/segmentBuilder";
import {
  getDesignTabTarget,
  getSegmentIcon,
  getWheelImage,
} from "../../../../redux/selectors/segmentBuilderSelectors";
import Tabs from "../../../Tabs";
import PortraitTab from "../PortraitTab";
import StyleTab from "../StyleTab";
import WallpaperTab from "../WallpaperTab";
import WheelPaletteTab from "../WheelPaletteTab";
import SegmentsTab from "../SegmentsTab";
import UploadedImage from "../PortraitTab/UploadedImage";
import ImageCropper from "../../../ImageCropper";
import { StyledTooltip } from "../../../IyugaTooltip";
import EssentialPackageIcon from "@assets/images/packages/essentialPackageIcon.svg";
import { useIfUserEligible } from "../../../../hooks/useIfUserEligible";
import { FEATURES } from "../../../../constants/features";

const mainTabs = ["Theme", "Portrait", "Wallpaper", "Style", "Segments"];

export default function DesignTab() {
  const segmentIcon = useSelector(getSegmentIcon);
  const dispatch = useDispatch();

  const [selectedOption, setSelectedOption] = useState(segmentIcon);
  const [selectedTab, setSelectedTab] = useState(mainTabs[0]);
  const designTabTarget = useSelector(getDesignTabTarget);

  const {
    isEligible,
    subscription,
    isCheckingEligibility,
    requiredSubscription,
  } = useIfUserEligible(FEATURES.ADV_PALLETE_GENERATOR);

  useEffect(() => {
    if (designTabTarget === "segments") {
      setSelectedTab("Segments");
    }
  }, [designTabTarget]);

  const handleTabChange = (e, newVal) => {
    setSelectedTab(newVal);
  };
  const [imageTitle, setImageTitle] = useState("");
  const [open, setOpen] = useState(false);
  const [originalImage, setOriginalImage] = useState(
    selectedImage?.url || null
  );
  const selectedImage = useSelector(getWheelImage);
  const wheelInformation = useSelector((state) => state.segmentBuilder);

  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
    dispatch(setSegmentIcon(event.target.value));
    dispatch(pushToHistoryAction()); // Push the new state to history
  };
  const [image, setImage] = useState(
    selectedImage?.url ||
      wheelInformation?.history[wheelInformation?.currentIndex]
        ?.wheel_center_media?.url
  );

  const handleRemoveImage = () => {
    setImage(null);
    dispatch(setWheelPortrait({ type: "image", title: "", url: "" }));
    dispatch(pushToHistoryAction()); // Push the new state to history
  };

  const handleImage = (val) => {
    setOriginalImage(val.src);
    setImage(val.src);
    setImageTitle(val.title);
    dispatch(setWheelPortrait({ type: "image", url: val.src }));
    dispatch(pushToHistoryAction()); // Push the new state to history
  };
  const handleEditImage = (val) => {
    setImage(val);
    dispatch(setWheelPortrait({ type: "image", title: imageTitle, url: val }));
    dispatch(pushToHistoryAction()); // Push the new state to history
  };

  const categoriesWithIcons = mainTabs.map((category) => {
    const config = {
      label: category,
      value: category,
    };

    // Add tooltip only to Image category when not eligible
    if (category === "Theme" && !isEligible) {
      config.customIcon = (
        <StyledTooltip
          title={"Essential Tier feature"}
          arrow
          placement="bottom"
          color={"#325AE9"}
          textColor={"#fff"}
        >
          <img src={EssentialPackageIcon} alt="info" />
        </StyledTooltip>
      );
    }

    return config;
  });

  return (
    <div>
      {/* <RadioButton
        options={options}
        selectedOption={selectedOption}
        onChange={handleRadioChange}
        orientation={"horizontal"}
        label={"Segment Display"}
      /> */}
      {/* <CustomTabs
        selectedTab={selectedTab}
        handleTabChange={handleTabChange}
        options={tabOptions}
      /> */}
      <Tabs
        // categories={mainTabs}
        categoriesWithIcons={categoriesWithIcons}
        selectedCategory={selectedTab}
        onCategoryChange={(_, val) => setSelectedTab(val)}
        variant="standard"
        sx={{
          "& .MuiTabs-flexContainer": {
            justifyContent: "space-between",
          },
        }}
      />
      {/* {image &&  <UploadedImage
                handleRemoveImage={handleRemoveImage}
                image={image}
                title={imageTitle}
                setOpen={setOpen}
              />}

<ImageCropper
        src={originalImage}
        open={open}
        handleClose={() => setOpen(false)}
        handleEditImage={handleEditImage}
        isWheelPortrait
      /> */}
      <div style={{ marginTop: "20px" }}>
        {selectedTab === mainTabs[0] && (
          <WheelPaletteTab showButtonAndTitle={true} />
        )}
        {selectedTab === mainTabs[1] && <PortraitTab />}
        {selectedTab === mainTabs[2] && <WallpaperTab />}
        {selectedTab === mainTabs[3] && <StyleTab />}
        {selectedTab === mainTabs[4] && <SegmentsTab />}
      </div>
    </div>
  );
}
